import React from 'react';
import About from '../components/About';

const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen pt-16 md:pt-20">
      <About />
    </div>
  );
};

export default AboutPage;
